import { CheckIcon, XIcon } from '@phosphor-icons/react'
import { FC, useMemo } from 'react'
import { AppCard, AppSpace, AppText, AppTitle } from '@/shared/ui'
import {
  cardBodyStyle,
  cardStyle,
  cardWithBackgroundStyle,
  Container,
  ContainerHeader,
  iconCheckStyle,
  iconCloseStyle,
  titleStyle
} from './PasswordStrength.styles'
import { useTranslation } from 'react-i18next'
import { PasswordValidationConfig } from '../ChangePasswordInputs/ChangePasswordInputs.types'
import { useChangePasswordValidations } from '../../../hooks/useChangePasswordValidations'

interface PasswordStrengthProps {
  password: string
  validationConfig: PasswordValidationConfig
  showDetailedView?: boolean
}

const PasswordStrength: FC<PasswordStrengthProps> = ({ password, showDetailedView = false, validationConfig }) => {
  const { t } = useTranslation()
  const { getAllPasswordRules } = useChangePasswordValidations(validationConfig)
  const rules = useMemo(() => {
    return getAllPasswordRules(password)
  }, [password, getAllPasswordRules])

  return (
    <AppCard style={showDetailedView ? cardWithBackgroundStyle : cardStyle} styles={{ body: cardBodyStyle }}>
      <ContainerHeader showDetailedView={showDetailedView}>
        <AppTitle level={5} style={titleStyle}>
          {t('password_strength.password_must_contain')}:
        </AppTitle>
      </ContainerHeader>
      <AppSpace direction='vertical' style={{ width: '100%' }}>
        {rules.map((rule) => (
          <Container key={rule.label}>
            {rule.isValid ? (
              <CheckIcon style={iconCheckStyle} />
            ) : (
              <XIcon style={{ ...iconCloseStyle, color: `${showDetailedView ? '#f5222d' : '#00000073'}` }} />
            )}
            <AppText
              type={rule.isValid ? 'success' : `${showDetailedView ? 'danger' : 'secondary'}`}
              style={{ transition: 'color 0.3s ease-in-out' }}
            >
              {rule.label}
            </AppText>
          </Container>
        ))}
      </AppSpace>
    </AppCard>
  )
}

export default PasswordStrength
